import cx from "classnames";

import { Tick } from "components/icons/generated";
import Icon from "ds/components/Icon";
import BadgeNext from "ds/components/BadgeNext";

import styles from "./styles.module.css";

type UserGuideGroupStatusIndicatorProps = {
  isCompleted: boolean;
  isInProgress: boolean;
};

const UserGuideGroupStatusIndicator = ({
  isCompleted,
  isInProgress,
}: UserGuideGroupStatusIndicatorProps) => {
  if (isInProgress) {
    return <BadgeNext type="weak" variant="blue" text="In progress" />;
  }

  return (
    <div
      className={cx(styles.statusIndicator, {
        [styles.completed]: isCompleted,
      })}
    >
      {isCompleted && <Icon src={Tick} color="on-solid-primary" />}
    </div>
  );
};

export default UserGuideGroupStatusIndicator;
